/**
 * Enterprise Lesson 3: Building Shots & Media Sequence
 * Checklist format — tutorial video at start, 11 tasks completed in any order.
 */
import type { EnterpriseLessonDef } from '@graphicsim/shared-types';

const TUTORIAL_VIDEO_URL = 'https://switchersimvids.blob.core.windows.net/vidstorage/Media-Sequence.mp4';

export const entGfx03: EnterpriseLessonDef = {
  id: 'ent-gfx-03',
  name: 'Building Shots & Media Sequence',
  mode: 'checklist',
  tutorialVideoUrl: TUTORIAL_VIDEO_URL,
  tasks: [
    {
      id: 't1',
      title: 'Open a Zone Preset',
      instruction: 'Choose "Standard Scoreboard B" from the zone preset list.',
      completionTrigger: {
        eventName: 'zone:presetChanged',
        matchField: 'presetIndex',
        matchValue: '4',
      },
    },
    {
      id: 't2',
      title: 'Switch to 6 Up Single',
      instruction: 'Change the active zone preset to "6 Up Single".',
      completionTrigger: {
        eventName: 'zone:presetChanged',
        matchField: 'presetIndex',
        matchValue: '1',
      },
    },
    {
      id: 't3',
      title: 'Add a Graphic to a Zone',
      instruction: 'Drag any template from the Library into the Project panel, then assign it to a zone in the Properties panel.',
      completionTrigger: {
        eventName: 'zone:assignmentChanged',
      },
    },
    {
      id: 't4',
      title: 'Add a Second Graphic to a Different Zone',
      instruction: 'Add a second template and assign it to a different zone, so two zones hold different items.',
      completionTrigger: {
        eventName: 'zone:assignmentChanged',
      },
    },
    {
      id: 't5',
      title: 'Take Multiple Zones Live',
      instruction: 'Play the items in both zones so they appear on the Program Monitor simultaneously.',
      completionTrigger: {
        eventName: 'monitor:takeToProgram',
      },
    },
    {
      id: 't6',
      title: 'Drag a Graphic into the Shot Launcher',
      instruction: 'Drag any item from the Project panel into the Shot Launcher to create a Shot.',
      completionTrigger: {
        eventName: 'shot:created',
      },
    },
    {
      id: 't7',
      title: 'Create a Second Shot',
      instruction: 'Create another Shot in the Shot Launcher by dragging a second item into it.',
      completionTrigger: {
        eventName: 'shot:created',
      },
    },
    {
      id: 't8',
      title: 'Trigger a Shot to Program',
      instruction: 'Click a Shot in the Shot Launcher to trigger it to the Program Monitor.',
      completionTrigger: {
        eventName: 'shot:triggered',
      },
    },
    {
      id: 't9',
      title: 'Import Media',
      instruction: 'Use File > New > Media Sequence (or File > Import > Media) to bring an image or video file into your Project.',
      completionTrigger: {
        eventName: 'project:itemAdded',
        matchField: 'item.mediaType',
        matchValue: 'oneOf:image|video',
      },
    },
    {
      id: 't10',
      title: 'Take Media to Program',
      instruction: 'Play one of your imported media items to send it to the Program Monitor.',
      completionTrigger: {
        eventName: 'monitor:takeToProgram',
        matchField: 'mediaType',
        matchValue: 'oneOf:image|video',
      },
    },
  ],
};
